import React from 'react';
import Layout from '../common/layouts';
import Callus from '../common/section/callus';
import { graphql } from 'gatsby';
import Hero from '../homepage/components/hero';
// import Card from "../homepage/components/card";
import Property from '../homepage/components/property';
import About from '../homepage/components/about';
import Bio from '../homepage/components/bio';
import Seo from '../common/seo';

import Amplify from 'aws-amplify';
import config from '../aws-exports';
Amplify.configure(config);

// exports
export default ({ data }) => {
  let post = data.featuredPost.edges[0].node;
  return (
    <Layout>
      <Seo
        title={'Home Page'}
        description={data.site.siteMetadata.description}
      />

      <Hero
        title={post.frontmatter.title}
        image={post.frontmatter.postImage.childImageSharp.fluid}
        to={post.frontmatter.slug}
        description={post.frontmatter.description}
      />

      <Callus
        message="We are happy to guide you through the process of investing in real estate
      and building wealth…"
      />

      <h1 className="dark-gray display fw4 f2-l f3 tc">Our Portfolio</h1>
      <div className="flex flex-wrap center mw9 justify-around pb3">
        {data.portfolio.edges.map(({ node }) => {
          return (
            <Property
              title={node.frontmatter.title}
              image={node.frontmatter.postImage.childImageSharp.fluid}
              to={node.frontmatter.slug}
              description={node.frontmatter.description}
            />
          );
        })}
        <div className="mw7 w-100 lh-copy serif pa2 flex flex-column justify-center f4">
          Aalon Capital LLC partners with established syndicators and property
          owners to become an member of the management in our investment
          properties.
        </div>
      </div>
      <About />
      <Bio />
    </Layout>
  );
};

export const query = graphql`
  query {
    featuredPost: allMarkdownRemark(
      limit: 1
      sort: { order: DESC, fields: frontmatter___date }
      filter: { frontmatter: { type: { eq: "post" } } }
    ) {
      edges {
        node {
          frontmatter {
            title
            description: metaDescription
            slug
            postImage {
              childImageSharp {
                fluid(maxWidth: 1920) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
        }
      }
    }
    cards: allMarkdownRemark(
      skip: 1
      limit: 3
      sort: { order: DESC, fields: frontmatter___date }
      filter: { frontmatter: { type: { eq: "post" } } }
    ) {
      edges {
        node {
          frontmatter {
            title
            description: metaDescription
            slug
            postImage {
              childImageSharp {
                fluid(maxWidth: 1920) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
        }
      }
    }
    portfolio: allMarkdownRemark(
      skip: 0
      limit: 4
      sort: { order: DESC, fields: frontmatter___date }
      filter: { frontmatter: { type: { eq: "property" } } }
    ) {
      edges {
        node {
          frontmatter {
            title
            description: metaDescription
            slug
            postImage {
              childImageSharp {
                fluid(maxWidth: 1920) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
        }
      }
    }
    site {
      siteMetadata {
        description
      }
    }
  }
`;
